import { SxProps, Theme } from '@mui/material';
import { animations } from 'theme';

export const styles = {
  cardContent: {
    ...animations.appearanceEffect,
  } as SxProps<Theme>,
  leftColumn: {
    ...animations.appearanceEffect,
  } as SxProps<Theme>,
  icon: {
    marginTop: '5px',
  } as SxProps<Theme>,
  units: {
    fontFamily: 'Rubik',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '16px',
    color: '#354052',
    marginTop: '15px',
    marginLeft: '3px',
  } as SxProps<Theme>,
  value: (value: number) =>
    ({
      fontFamily: 'Rubik',
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: '32px',
      color: '#354052',
      marginLeft: '10px',
      letterSpacing: value > 999 ? '-2px' : 'normal',
    } as SxProps<Theme>),
  leftColUpperRowDescriptionSubRow: {
    fontFamily: 'Rubik',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '14px',
    lineHeight: '16px',
    color: '#7f8fa4',
  } as SxProps<Theme>,
  leftColBottomRow: {
    fontFamily: 'Rubik',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '12px',
    lineHeight: '14px',
    borderTop: '1px solid #c5d0de',
  } as SxProps<Theme>,
  rightColumn: {
    ...animations.appearanceEffect,
  } as SxProps<Theme>,
  rightColumnRow: {
    borderBottom: '1px solid #c5d0de',
  } as SxProps<Theme>,
  valueAndUnitWrapper: {
    marginRight: '5px',
  } as SxProps<Theme>,
  rightColumnRowValueSubRowItemUnits: {
    fontFamily: 'Rubik',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '14px',
    color: '#354052',
    marginTop: '5px',
  } as SxProps<Theme>,
  rightColumnRowValueSubRowItemValue: {
    fontFamily: 'Rubik',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '20px',
    color: '#354052',
    marginRight: '5px',
  } as SxProps<Theme>,
  rightColumnRowDescriptionSubRow: {
    fontFamily: 'Rubik',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '14px',
    color: '#7f8fa4',
  } as SxProps<Theme>,
};
